import initialState from "./initial.values";

const rootReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "HEADER_DATA":
      return { ...state, header_data: action.payload };
    case "SET_RESERVATION_DETAILS":
      return { ...state, reservationDetails: action.payload };
    case "SET_TEMP_BOOKING_DETAILS":
      return { ...state, tempBookingDetails: action.payload };
    default:
      return state;
  }
};

export default rootReducer;
